import { useRef, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import LeftSubMenu from "../LeftSubMenu";
import { logout } from "../../../../utils/auth";
import "../../../../assets/css/style.css";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import MarketRules from "../../../agent/popup/market-rules";
import StartUpPopUp from "../../popup/startup_popup";

//
import {
  setEventData,
  setEventLoading,
  setEventError
} from "../../../../store/eventSlice";

import { clearUserData } from "../../../../store/userSlice";

import { setLoader } from "../../../../store/loaderSlice";
import axiosInstance from "../../../../utils/axiosInstance";
import TermsConditions from "../../../agent/popup/terms-conditions";
import { MessageCircle } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
const ClientLayout = ({ children, showLoader = true }) => {
  const [displaySidebar, setDisplaySidebar] = useState(false);
  const [displaySubMenu, setDisplaySubMenu] = useState(false);
  const [displayTopRightMenu, setDisplayTopRightMenu] = useState(false);
  const [gameType, setGameType] = useState(0);
  const isloader = false;
  const [showMarketRules, setShowMarketRules] = useState(false);
  const [showTermsConditons, setShowTermsConditions] = useState(false);
  const [showAutoDepositIcons, setShowAutoDepositIcons] = useState(false);

  const [startUpPopup, setStartUpPopup] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loader = useSelector((state) => state.loader);
  const userInfo = useSelector((state) => state.userStore);

  function ShowLeftMenuBySports(displaySubMenu, game_type) {
    setDisplaySubMenu(displaySubMenu);
    setGameType(game_type);
  }

  useEffect(() => {
    const fetchEvents = async () => {
      //console.log("Fetching events...");
      try {
        console.log("Trying to fetch events!");
        await dispatch(setLoader(true));
        const response = await axiosInstance.get("/events");

        if (response.data.result !== "") {
          await dispatch(setEventData(response.data));
        }
        await dispatch(setLoader(false));
      } catch (error) {
        console.error("Error fetching events:", error);
        if (error?.response?.status === 401) {
          dispatch(clearUserData());
        }
      }
    };

    fetchEvents();
  }, []);

  useEffect(
    (userInfo) => {
      if (userInfo !== "") {
        setShowAutoDepositIcons(true);
      }
    },
    [userInfo]
  );

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  const topRightMenuRef = useRef(null);
  //const navigate = useNavigate();

  // Function to handle clicks outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        topRightMenuRef.current &&
        !topRightMenuRef.current.contains(event.target)
      ) {
        setDisplayTopRightMenu(false); // Or update any value/state you want
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [topRightMenuRef]);

  const username = userInfo.data?.uname ?? "";
  const balance = Math.round(userInfo.data?.bz_balance ?? 0);
  const expouser = Math.round(
    (userInfo.data?.opin_bal ?? 0) - (userInfo.data?.bz_balance ?? 0)
  );
  const showAutoWallet = !!userInfo.data?.upline_allow_auto_deposit;
  const sponsorWhatsappNo = (userInfo.data?.sponsor_whatsapp_no || "").trim();
  const sponsorWhatsappUrl = sponsorWhatsappNo
    ? `https://wa.me/${sponsorWhatsappNo.replace(/\D/g, "")}`
    : "";

  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const popupShown = localStorage.getItem("popupShown");
    if (!popupShown) {
      setShowPopup(true);
      localStorage.setItem("popupShown", "true");
    }

    const timer = setTimeout(() => {
      setShowPopup(false);
    }, 2000);

    return () => clearTimeout(timer); // Cleanup
  }, []);

  return (
    <div className={displaySidebar ? "body-active" : ""}>
      {loader.loading && showLoader && (
        <div
          style={{
            position: "absolute",
            zIndex: "1000",
            background: "#ddd",
            width: "100%",
            height: "20%",
            opacity: 1
          }}
        >
          <div className="top_loader_css">
            <img src="../assets/images/loadinggif.gif" alt="Loader" />
          </div>
        </div>
      )}
      <style>{`
    .dropdown-toggle::after {
        display: none;
        width: 0;
        height: 0;
        margin-left: 0.255em;
        vertical-align: 0.255em;
        content: "";
        border-top: 0.3em solid;
        border-right: 0.3em solid transparent;
        border-bottom: 0;
        border-left: 0.3em solid transparent;
    }

    @keyframes spin {
        from {
            transform: rotateY(0deg);
            moz-transform: rotateY(0deg);
            ms-transform: rotateY(0deg);
        }
        to {
            transform: rotateY(360deg);
            moz-transform: rotateY(360deg);
            ms-transform: rotateY(360deg);
        }
    }

    @-webkit-keyframes spin {
        from {
            -webkit-transform: rotateY(0deg);
        }
        to {
            -webkit-transform: rotateY(360deg);
        }
    }

    .imageSpin2 {
        transition-delay: 3s;
        animation-name: spin;
        animation-iteration-count: infinite;
        animation-duration: inherit;
        -webkit-animation-name: spin;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-timing-function: initial;
        -webkit-animation-duration: 3s;
        -webkit-animation-delay: 2s;
    }

    #invertcolor {
        filter: invert(100%);
        -webkit-filter: invert(100%);
        animation-name: spinning-circle;
        animation-duration: 3s;
        animation-iteration-count: infinite;
    }

    @-webkit-keyframes spinning-circle {
        0% {
            -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
        }
        100% { 
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .blinkRow {
        animation: blinkingBackground 2s infinite;
    }

    @keyframes blinkingBackground {
        0% {
            background-color: #ff0c0e;
        }
        50% {
            background-color: #0163d7;
        }
        100% {
            background-color: #02b181;
        }
    }

    @media only screen and (max-width: 767px) {
        .other-page-menu {
            padding-left: 0;
        }
        .header-menu {
            padding-right: 0px !important;
        }
        .home-section .home-content {
            padding-top: 12px;
            padding-bottom: 13px;
        }
        .balance-bar-wrapper {
            padding: 6px 4px;
        }
    }
  .exgameblinker {
      animation: animate 8s linear infinite;
  }

  @keyframes animate{
    0%{
      background-color:red;
    }
    25%{
      background-color:inherit;
    }
    50%{
      background-color:inherit;
    }
    75%{
      background-color:inherit;
    }
    100%{
      background-color:red;
    }
  }

  #invertcolor3 {
    filter: invert(100%);
    -webkit-filter: invert(100%);
    animation-name: spin;
    animation-duration: 3s;
    animation-iteration-count: infinite;
    
}

#invertcolor2 {
  filter: invert(100%);
  -webkit-filter: invert(100%);
  animation-name: spin;
  animation-duration: 4s;
  animation-iteration-count: infinite;
  max-height: 30px;
}

#spinning-circle {
  animation-name: spinning-circle;
  animation-duration: 5s;
  animation-iteration-count: infinite;
}



 
.Galaxyblinker {
  animation: animateGradient 12s linear infinite;
}
 

@keyframes animateGradient {
  0%{
    background-color:#ab63f4;
  }
  25%{
    background-color:inherit;
  }
  50%{
    background-color:inherit;
  }
  75%{
    background-color:inherit;
  }
  100%{
    background-color:#ab63f4;
  }
}

  `}</style>
      <div className="sidebar side-close left-sidebar-menu">
        <div className="logo-details">
          <Link to="/home" style={{ textDecoration: "none" }}>
            <span
              className="logo_name"
              style={{ fontSize: 20, color: "#04b181", fontWeight: "bold" }}
            >
              BPEXCH
            </span>
          </Link>
        </div>
        <ul className="nav-links" style={{ paddingTop: "0px" }}>
          <nav className="navbar navbar-expand-lg">
            <button
              style={{ display: "none" }}
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarTogglerDemo01"
              aria-controls="navbarTogglerDemo01"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />{" "}
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarTogglerDemo01"
              style={{ background: "var(--theme-color)" }}
            >
              <div className="mobile-view-icons">
                <div>
                  <ul
                    className="top-nav"
                    style={{ paddingTop: 10, fontWeight: "normal" }}
                  >
                    <li>
                      <i
                        style={{
                          lineHeight: "unset",
                          height: "unset",
                          minWidth: "unset",
                          color: "white"
                        }}
                        className="bx bx-menu-new2"
                        onClick={() => {
                          setDisplaySidebar(!displaySidebar);
                        }}
                      />
                    </li>

                    <li style={{ paddingTop: "3px" }}>
                      <Link to="/home" style={{ textDecoration: "none" }}>
                        <span
                          className="logo_name"
                          style={{
                            fontSize: 21,
                            color: "#04b181",
                            fontWeight: "bold"
                          }}
                        >
                          BPEXCH
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <LeftSubMenu
                displaySubMenu={displaySubMenu}
                setDisplaySubMenu={setDisplaySubMenu}
                gameType={gameType}
              />
              <ul className="navbar-nav">
                <hr
                  style={{
                    marginLeft: 10,
                    borderTop: "1px solid #fff",
                    marginRight: 10
                  }}
                />

                <li className="nav-item dropdown">
                  {" "}
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => ShowLeftMenuBySports(!displaySubMenu, 2)}
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    {" "}
                    <img
                      src="/assets/images/menu-icon/soccer.svg"
                      alt="Box Icon"
                    />
                    <span
                      className="client_site_family"
                      style={{ fontWeight: "500" }}
                    >
                      Soccer
                    </span>
                  </a>
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => ShowLeftMenuBySports(!displaySubMenu, 3)}
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    {" "}
                    <img
                      src="/assets/images/menu-icon/tennis.svg"
                      alt="Box Icon"
                    />
                    <span className="client_site_family">Tennis</span>
                  </a>
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => ShowLeftMenuBySports(!displaySubMenu, 1)}
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    {" "}
                    <img
                      src="/assets/images/menu-icon/cricket.svg"
                      alt="Box Icon"
                    />
                    <span className="client_site_family">Cricket</span>
                  </a>
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => ShowLeftMenuBySports(!displaySubMenu, 4)}
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    {" "}
                    <img
                      src="/assets/images/menu-icon/horse.svg"
                      alt="Box Icon"
                    />
                    <span className="client_site_family">Horse Race</span>
                  </a>
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={() => ShowLeftMenuBySports(!displaySubMenu, 5)}
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    {" "}
                    <img
                      src="/assets/images/menu-icon/greyhound-racing.svg"
                      alt="Box Icon"
                    />
                    <span className="client_site_family">Greyhound</span>
                  </a>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="/sports-book"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/sultaan-casino.svg"
                      alt="WC"
                      className="imageSpin2"
                    />
                    <span className="client_site_family">Sports Book</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <Link
                    className="nav-link dropdown-toggle"
                    to="/royal-star"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <i
                      style={{
                        fontSize: "17px",
                        minWidth: "auto",
                        color: "white",
                        lineHeight: "unset",
                        height: "auto"
                      }}
                      className="fas fa-star fa-2x fa-spin fa-lg"
                    />
                    <span
                      style={{ paddingLeft: "10px" }}
                      className="client_site_family"
                    >
                      RoyalStar Casino
                    </span>
                  </Link>
                  {/*aura*/}
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <Link
                    className="nav-link dropdown-toggle"
                    to="/royal-casino/AC"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      id="spinning-circle"
                      src="/assets/images/menu-icon/livegameing.png"
                      alt="WC"
                    />
                    <span className="client_site_family">Star Casino</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <Link
                    className="nav-link dropdown-toggle"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                    to="/world-casino"
                  >
                    {" "}
                    <img
                      style={{ background: "invert(100%)" }}
                      id="invertcolor"
                      src="/assets/images/menu-icon/worldcasinosvg.png"
                      alt="WC"
                    />
                    <span className="client_site_family">World Casino</span>
                  </Link>
                </li>

                {/*multi provider*/}
                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                    to="/multi-casino"
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/sultaan-casino.svg"
                      alt="WC"
                      className="imageSpin2"
                    />
                    <span className="client_site_family">Royal Casino</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    to="/betfair-studio"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/Bgame.png"
                      alt="WC"
                      id="invertcolor2"
                      className="imageSpin2"
                    />
                    <span className="client_site_family">BetFairGames</span>
                  </Link>
                </li>

                <li className="nav-item exgameblinker">
                  {/*--webkit-filter: invert(100%);-*/}
                  <Link
                    className="nav-link"
                    to="/tp-studio"
                    style={{
                      display: "block",
                      marginBottom: "0px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <img
                      id="invertcolor3"
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/menu-icon/TPS.png"
                      alt="WC"
                      className="imageSpin2"
                    />
                    <span className="client_site_family">TeenPatti Studio</span>
                  </Link>
                  {/*Studio*/}
                </li>

                <li className="nav-item Galaxyblinker">
                  <Link
                    className="nav-link"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                    to="/galaxy-casino"
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/menu-icon/Glogo.png"
                      alt="WC"
                      className="imageSpin2"
                    />
                    <span
                      style={{ fontSize: "16px" }}
                      className="client_site_family"
                    >
                      Galaxy Casino
                    </span>
                  </Link>
                  {/*Studio*/}
                </li>

                <li>
                  {" "}
                  <hr style={{ border: "solid 1px #4f6680" }} />
                </li>

                <li className="nav-item dropdown">
                  {" "}
                  <Link
                    className="nav-link dropdown-toggle"
                    to="/current-position-list"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/menu-icon/colossus.svg"
                      alt="WC"
                    />
                    <span className="client_site_family">Current Position</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                    to="/home"
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/menu-icon/soccer.svg"
                      alt="WC"
                    />
                    <span className="client_site_family">All Sports</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                    to="/results"
                  >
                    <img
                      style={{ background: "invert(100%)" }}
                      src="/assets/images/menu-icon/clipboard.svg"
                      alt="WC"
                    />
                    <span className="client_site_family">Results</span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    href="# "
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowMarketRules(true);
                    }}
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <i
                      style={{
                        minWidth: "24px",
                        height: "auto",
                        color: "white"
                      }}
                      className="fa fa-info-circle"
                    />
                    <span
                      className="client_site_family"
                      style={{ paddingLeft: "10px" }}
                    >
                      Market Rules
                    </span>
                  </Link>
                </li>

                <li className="nav-item dropdown">
                  <Link
                    className="nav-link dropdown-toggle"
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      setShowTermsConditions(true);
                    }}
                    style={{
                      display: "block",
                      marginBottom: "3px",
                      fontWeight: "500",
                      color: "#fff",
                      fontSize: "14px",
                      height: "40px",
                      lineHeight: "40px",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      overflow: "hidden"
                    }}
                  >
                    <i
                      style={{
                        minWidth: "24px",
                        height: "auto",
                        color: "white"
                      }}
                      className="fa fa-info-circle"
                    />
                    <span
                      className="client_site_family"
                      style={{ paddingLeft: "10px" }}
                    >
                      Terms &amp; Conditions
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </nav>
        </ul>
      </div>

      <section className="home-section" style={{ background: "#dee4ea" }}>
        <div className="home-content">
          <style />
          <div className="menu-content-left-top">
            <i
              className="bx bx-menu-new"
              onClick={() => {
                setDisplaySidebar(!displaySidebar);
              }}
            />
            <ul className="top-nav">
              <li>
                <Link
                  to="/home"
                  style={{
                    WebkitTextDecoration: "none",
                    textDecoration: "none",
                    fontSize: "16px",
                    fontWeight: 500,
                    lineHeight: 1.5
                  }}
                  className="client_site_family"
                >
                  &nbsp;&nbsp;Dashboard
                </Link>
              </li>
            </ul>
          </div>
          <div className="header-tickercontainer">
            <marquee
              style={{ color: "#ffffff", fontWeight: "bold" }}
              className="client_site_family"
            >
              Welcome to Exchange. &nbsp;
            </marquee>
          </div>
          <div className="right-side-dropdowns-menu">
            <div
              className={
                displayTopRightMenu
                  ? "dropdown-right-side is-active"
                  : "dropdown-right-side"
              }
              ref={topRightMenuRef}
            >
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  marginRight: "6px",
                  verticalAlign: "middle"
                }}
              >
                {sponsorWhatsappUrl ? (
                  <a
                    href={sponsorWhatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#00b281",
                      color: "white",
                      borderRadius: "4px",
                      padding: "6px 8px",
                      lineHeight: 1,
                      textDecoration: "none"
                    }}
                    title="WhatsApp Support"
                    aria-label="WhatsApp Support"
                  >
                    <FaWhatsapp
                      size={17}
                      color="white"
                      strokeWidth={2}
                      style={{ cursor: "pointer" }}
                    />
                    {/* <MessageCircle size={16} strokeWidth={2} color="white" />*/}
                  </a>
                ) : null}

                {showAutoDepositIcons == true && showAutoWallet ? (
                  <>
                    <Link
                      to="/auto-wallet/deposit"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <input
                        type="button"
                        value="D"
                        style={{
                          background: "green",
                          border: "0px",
                          color: "white",
                          borderRadius: "4px",
                          padding: "6px 12px",
                          fontWeight: "bold",
                          cursor: "pointer",
                          lineHeight: 1
                        }}
                      />
                    </Link>
                    <Link
                      to="/auto-wallet/withdrawal"
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      <input
                        type="button"
                        value="W"
                        style={{
                          background: "red",
                          border: "0px",
                          color: "white",
                          borderRadius: "4px",
                          padding: "6px 12px",
                          fontWeight: "bold",
                          cursor: "pointer",
                          lineHeight: 1
                        }}
                      />
                    </Link>
                  </>
                ) : null}
              </span>
              <span className="designation">
                {" "}
                B: Rs.{" "}
                <span id="span_left_bal" style={{ fontWeight: "700" }}>
                  {formatTruncate(balance)}
                </span>{" "}
                | L:
                <Link
                  to="/bet-history"
                  style={{
                    color: "white",
                    WebkitTextDecoration: "none",
                    textDecoration: "none",
                    fontWeight: "700"
                  }}
                >
                  <span id="span_strip_exp" style={{ fontWeight: "800" }}>
                    <span style={{ display: expouser != 0 ? "" : "none" }}>
                      -
                    </span>
                    {formatTruncate(expouser)}
                  </span>
                </Link>{" "}
              </span>
              <div className="dropdown-title">
                {" "}
                <a
                  href="#"
                  style={{
                    WebkitTextDecoration: "none",
                    textDecoration: "none"
                  }}
                  className="btnbtn-primary1 toggle"
                  onClick={() => setDisplayTopRightMenu(!displayTopRightMenu)}
                >
                  {username} <i className="fa-solid fa-caret-down" />
                </a>{" "}
              </div>
              <ul
                className="dropdown-menu list-group"
                style={{ borderRadius: "3px", padding: ".45rem 0.5rem" }}
              >
                <li>
                  <Link to="/accounts/account-statement">Statement</Link>
                </li>
                <li>
                  <Link to="/results">Result</Link>
                </li>
                <li>
                  <Link to="/accounts/profit-loss">Profit Loss</Link>
                </li>
                <li>
                  <Link to="/bet-history">Bet History</Link>
                </li>
                <li>
                  <Link to="/profile">Profile</Link>
                </li>
                {/*<li><a href="/user/reset-password">Change Password</a></li>*/}
                <li>
                  <a href="#" onClick={() => logout(dispatch, navigate)}>
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>{" "}
        </div>
        <div
          className="right-side-wrapper-row"
          style={{ background: "#dde1e5" }}
        >
          {children}
        </div>
      </section>
      <section
        className="footer-section"
        style={{ marginTop: "2px", borderTop: "0px" }}
      >
        <div style={{ background: "#4ebd74", height: "6px" }}></div>
        <div style={{ background: "var(--theme-color)", height: "43px" }}></div>
      </section>

      {showMarketRules && (
        <MarketRules onClose={() => setShowMarketRules(false)} />
      )}
      {showTermsConditons && (
        <TermsConditions onClose={() => setShowTermsConditions(false)} />
      )}

      {showPopup && (
        <StartUpPopUp onClose={() => setShowPopup(false)}></StartUpPopUp>
      )}
    </div>
  );
};

export default ClientLayout;
